import React, { forwardRef } from 'react';
import styled from '@emotion/styled';

import { Modal } from '../../../../components/Modals/Modal';
import ModalTriggerContainer from '../../../../components/Modals/ModalTriggerContainer';
import { ModalProvider } from '../../../../context/ModalContext';
import InvitedJobFilterModal from '../../../../components/Modals/ModalsActions/InvitedJobFilterModal';

const InvitedJobFilterButton = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <ModalProvider>
      <ModalTriggerContainer ref={ref}>
        <None />
      </ModalTriggerContainer>
      <Modal>
        <InvitedJobFilterModal />
      </Modal>
    </ModalProvider>
  );
});

export default InvitedJobFilterButton;

const None = styled.div`
  display: none;
`;
